export type Tab = 'feed' | 'saved' | 'profile';

const TABS: Array<{ id: Tab; label: string }> = [
  { id: 'feed', label: 'Feed' },
  { id: 'saved', label: 'Saved' },
  { id: 'profile', label: 'Profile' },
];

// Fixed to the bottom because this is a phone-first app held one-handed. The
// safe-area padding keeps the labels clear of the iOS home indicator.
export function TabBar({ active, onChange }: { active: Tab; onChange: (t: Tab) => void }) {
  return (
    <nav
      role="tablist"
      aria-label="Sections"
      className="fixed inset-x-0 bottom-0 z-10 border-t border-ink bg-paper/95 backdrop-blur-sm"
    >
      <div className="mx-auto grid max-w-2xl grid-cols-3 pb-[env(safe-area-inset-bottom)]">
        {TABS.map((tab) => {
          const selected = tab.id === active;
          return (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={selected}
              onClick={() => onChange(tab.id)}
              className={`relative py-3.5 font-mono text-[0.6875rem] tracking-[0.16em] uppercase transition-colors ${
                selected ? 'text-ink' : 'text-ink-faint hover:text-ink-soft'
              }`}
            >
              {tab.label}
              {/* The accent marks position, not decoration — one mark, one place. */}
              <span
                aria-hidden="true"
                className={`absolute inset-x-[35%] top-0 h-[3px] ${selected ? 'bg-accent' : 'bg-transparent'}`}
              />
            </button>
          );
        })}
      </div>
    </nav>
  );
}
